import useTranslation from 'next-translate/useTranslation'
import {
  Layout,
  StickyContentSection,
  ContentNotFound,
} from '../components/common'
import { useRouter } from 'next/router'
import { PageService } from '../services'

const KVKKScreen = ({ pageData, global: { navigation } }) => {
  const { t } = useTranslation()
  const { asPath } = useRouter()

  if (pageData.error) {
    return (
      <Layout
        title={t('common:ssmPageTitle')}
        navigation={navigation}
        path={asPath}
      >
        <ContentNotFound infoType="serverSideError" />
      </Layout>
    )
  }

  return (
    <Layout
      title={pageData?.data?.title || t('legal:kvkk.pageTitle')}
      navigation={navigation}
      path={asPath}
    >
      <StickyContentSection
        title={pageData?.data?.title || t('legal:kvkk.pageTitle')}
        descriptions={pageData?.data?.htmlContent}
      />
    </Layout>
  )
}

export default KVKKScreen

export async function getStaticProps({ locale }) {
  const pageData = await PageService.getBasicPage(locale, 'kvkk')

  return {
    props: { pageData },
  }
}
